<template>
  <Logo />
  <div :style="`background-image:url(${backgroundBg});`" class="page-container">
    <van-form class="form" @submit="onSubmit">
      <div class="form-title">
        <p>USER LOGIN</p>
        <h2>登录到平台</h2>
        <h4>请使用学校统一身份认证登录</h4>
      </div>
      <div class="form-body"></div>
      <!-- <div class="forget">
      <router-link to="/forget" custom v-slot="{ navigate }">
        <span @click="navigate" role="link">忘记密码</span>
      </router-link>
    </div> -->
      <div>
        <van-button
          round
          block
          :style="`background-image:url(${buttonBg});`"
          class="form-button"
          type="primary"
          native-type="submit"
          :loading="loading"
        >
          进入统一身份验证
        </van-button>

        <!-- <van-button
          round
          block
          :style="`background-image:url(${buttonBg}); filter:brightness(1.4);`"
          class="form-button"
          type="primary"
          native-type="submit"
          :loading="loading"
        >
          短信验证码登录
        </van-button> -->
        <span class="form-text">
          <van-checkbox
            class="form-text-checkbox"
            v-model="checked"
          ></van-checkbox>
          <span style="font-size: 14px" :class="checkedShaky ? 'shaky' : ''">
            我同意绑定微信作为<span style="color: #396afc">学校内部管理</span
            >使用</span
          >
        </span>
        <div style="position: absolute;bottom: 15px;left: 40%">
          <span style="color: #396afc;font-size: 12px" @click="tishi">新生登录提示</span><br>
        </div>
      </div>
    </van-form>
  </div>
</template>

<script lang="ts">
import Logo from './components/Logo.vue'
import { defineComponent, onMounted } from 'vue'
import { useSigninEffect } from './hooks/useSigninEffect'
import request from '@/utils/request'
import {Dialog} from "vant";

export default defineComponent({
  name: 'Signin',
  components: {
    Logo
  },
  setup() {
    const { username, password, loading, onSubmit, checked, checkedShaky } =
      useSigninEffect()
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const backgroundBg = require('@/assets/login/bg.png')
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const buttonBg = require('@/assets/login/button.png')
    const tishi = () => {
      Dialog.alert({
        title: '提示',
        width: '320px',
        className: 'fontCss',
        messageAlign: 'left',
        message: '<span style="font-size: 16px;line-height: 1"><p>账号规则：用户名为学号</p><br>' +
            '<p>密码规则：15位身份证号码取最后6位为密码。18位身份证号码取去掉最后1位的倒数6位为密码( 即第12—第17位)，如输入密码无法登录，请尝试用学号作为初始密码。</p></span>',
        allowHtml:true
      })
    }
    onMounted(() => {
      request({
        url: '/destroyCookie',
        method: 'GET'
      }).then(res => {
        if (res.status) {
          console.log('cookise 清除成功')
        }
      })
    })
    return {
      username,
      password,
      loading,
      backgroundBg,
      buttonBg,
      onSubmit,
      tishi,
      checked,
      checkedShaky
    }
  }
})
</script>

<style lang="scss" scoped>
.form {
  padding: 40px;
  padding-top: 200px;
  &-title {
    font-size: 52px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #333333;
    line-height: 50px;
    p {
      font-size: 20px;
      font-family: PingFang SC;
      font-weight: normal;
      color: #666666;
    }
    h4 {
      font-size: 22px;
      font-family: PingFang SC;
      font-weight: normal;
      color: #999999;
      line-height: 28px;
      margin-top: 20px;
    }
  }
  &-button {
    background-size: 90vw 80px;
    width: 90vw;
    height: 80px;
    opacity: 0.6;
    border-radius: 10px;
    font-size: 30px;
    opacity: 1;
    margin-bottom: 30px;
    box-shadow: 0px 2px 8px 0px rgba(11, 37, 113, 0.3);
  }
  &-text {
    width: 100vw;
    height: 21px;
    width: 169px;
    height: 10px;
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #929ab3;
    line-height: 15px;
    &-checkbox {
      display: inline-block;
    }
  }
  &-body {
    padding-top: 30px;
    height: 100px;
    padding-bottom: 30px;
    &-verify {
      height: 60px;
      border-radius: 6px;
    }
    &::v-deep {
      .van-icon {
        position: absolute;
        top: 0px;
        right: 0px;
        width: 1em;
        height: 1em;
      }
    }
  }
}
.fontCss{
  font-size: 16px;
}
.shaky {
  display: inline-block;
  padding: 1px;
  -webkit-transform-origin: center center;
  -ms-transform-origin: center center;
  transform-origin: center center;
  -webkit-animation-name: shaky-slow;
  -ms-animation-name: shaky-slow;
  animation-name: shaky-slow;
  -webkit-animation-duration: 4s;
  -ms-animation-duration: 4s;
  animation-duration: 4s;
  -webkit-animation-iteration-count: infinit;
  -ms-animation-iteration-count: infinit;
  animation-iteration-count: infinit;
  -webkit-animation-timing-function: ease-in-out;
  -ms-animation-timing-function: ease-in-out;
  animation-timing-function: ease-in-out;
  -webkit-animation-delay: 0s;
  -ms-animation-delay: 0s;
  animation-delay: 0s;
  -webkit-animation-play-state: running;
  -ms-animation-play-state: running;
  animation-play-state: running;
}
@-webkit-keyframes shaky-slow {
  0% {
    -webkit-transform: translate(0px, 0px);
  }
  2% {
    -webkit-transform: translate(-1px, 0px);
  }
  4% {
    -webkit-transform: translate(1.3px, 0px);
  }
  6% {
    -webkit-transform: translate(1.4px, 0px);
  }
  8% {
    -webkit-transform: translate(-1.3px, -0px);
  }
  10% {
    -webkit-transform: translate(1.4px, 0px);
  }
  12% {
    -webkit-transform: translate(-1.3px, -0px);
  }
  14% {
    -webkit-transform: translate(1.5px, 0px);
  }
  16% {
    -webkit-transform: translate(1.5px, -0px);
  }
  18% {
    -webkit-transform: translate(1.3px, -0px);
  }
  20% {
    -webkit-transform: translate(1px, 0px);
  }
  22% {
    -webkit-transform: translate(1.3px, 0px);
  }
  24% {
    -webkit-transform: translate(-1.4px, -0px);
  }
  26% {
    -webkit-transform: translate(1.3px, -0px);
  }
  28% {
    -webkit-transform: translate(1.6px, -0px);
  }
  30% {
    -webkit-transform: translate(-1.3px, -0px);
  }
  32% {
    -webkit-transform: translate(-1px, 0px);
  }
  34% {
    -webkit-transform: translate(1.3px, 0px);
  }
  36% {
    -webkit-transform: translate(1.3px, 0px);
  }
  38% {
    -webkit-transform: translate(1.3px, -0px);
  }
  40% {
    -webkit-transform: translate(-1.4px, -0px);
  }
  42% {
    -webkit-transform: translate(-1.4px, 0px);
  }
  44% {
    -webkit-transform: translate(-1.6px, 0px);
  }
  46% {
    -webkit-transform: translate(-2.1px, -0px);
  }
  48% {
    -webkit-transform: translate(1px, 0px);
  }
  50% {
    -webkit-transform: translate(1.6px, 0px);
  }
  52% {
    -webkit-transform: translate(-1.4px, 0px);
  }
  54% {
    -webkit-transform: translate(1.6px, -0px);
  }
  56% {
    -webkit-transform: translate(1.3px, -0px);
  }
  58% {
    -webkit-transform: translate(-1.3px, -0px);
  }
  60% {
    -webkit-transform: translate(1.3px, 0px);
  }
  62% {
    -webkit-transform: translate(0px, 0px);
  }
  64% {
    -webkit-transform: translate(-1.6px, -0px);
  }
  66% {
    -webkit-transform: translate(1.6px, -0px);
  }
  68% {
    -webkit-transform: translate(0px, -0px);
  }
  70% {
    -webkit-transform: translate(-1.6px, 0px);
  }
  72% {
    -webkit-transform: translate(-1.6px, 0px);
  }
  74% {
    -webkit-transform: translate(1.3px, -0px);
  }
  76% {
    -webkit-transform: translate(1.4px, 0px);
  }
  78% {
    -webkit-transform: translate(-1px, 0px);
  }
  80% {
    -webkit-transform: translate(1.4px, 0px);
  }
  82% {
    -webkit-transform: translate(-1.6px, -0px);
  }
  84% {
    -webkit-transform: translate(-1.4px, 0px);
  }
  86% {
    -webkit-transform: translate(1px, 0px);
  }
  88% {
    -webkit-transform: translate(-1.4px, 0px);
  }
  90% {
    -webkit-transform: translate(-1.6px, -0px);
  }
  92% {
    -webkit-transform: translate(-1.6px, 0px);
  }
  94% {
    -webkit-transform: translate(-1.6px, -0px);
  }
  96% {
    -webkit-transform: translate(-1.4px, 0px);
  }
  98% {
    -webkit-transform: translate(1.3px, 0px);
  }
}
@keyframes shaky-slow {
  0% {
    transform: translate(0px, 0px);
  }
  2% {
    transform: translate(-1px, 0px);
  }
  4% {
    transform: translate(1.3px, 0px);
  }
  6% {
    transform: translate(1.4px, 0px);
  }
  8% {
    transform: translate(-1.3px, 0px);
  }
  10% {
    transform: translate(1.4px, 0px);
  }
  12% {
    transform: translate(-1.3px, 0px);
  }
  14% {
    transform: translate(1.5px, 0px);
  }
  16% {
    transform: translate(1.5px, 0px);
  }
  18% {
    transform: translate(1.3px, 0px);
  }
  20% {
    transform: translate(1px, 0px);
  }
  22% {
    transform: translate(1.3px, 0px);
  }
  24% {
    transform: translate(-1.4px, 0px);
  }
  26% {
    transform: translate(1.3px, 0px);
  }
  28% {
    transform: translate(1.6px, 0px);
  }
  30% {
    transform: translate(-1.3px, 0px);
  }
  32% {
    transform: translate(-1px, 0px);
  }
  34% {
    transform: translate(1.3px, 0px);
  }
  36% {
    transform: translate(1.3px, 0px);
  }
  38% {
    transform: translate(1.3px, -0px);
  }
  40% {
    transform: translate(-1.4px, -0px);
  }
  42% {
    transform: translate(-1.4px, 0px);
  }
  44% {
    transform: translate(-1.6px, 0px);
  }
  46% {
    transform: translate(-2.1px, -0px);
  }
  48% {
    transform: translate(1px, 0px);
  }
  50% {
    transform: translate(1.6px, 0px);
  }
  52% {
    transform: translate(-1.4px, 0px);
  }
  54% {
    transform: translate(1.6px, -0px);
  }
  56% {
    transform: translate(1.3px, -0px);
  }
  58% {
    transform: translate(-1.3px, -0px);
  }
  60% {
    transform: translate(1.3px, 0px);
  }
  62% {
    transform: translate(0px, 0px);
  }
  64% {
    transform: translate(-1.6px, -0px);
  }
  66% {
    transform: translate(1.6px, -0px);
  }
  68% {
    transform: translate(0px, -0px);
  }
  70% {
    transform: translate(-1.6px, 0px);
  }
  72% {
    transform: translate(-1.6px, 0px);
  }
  74% {
    transform: translate(1.3px, -0px);
  }
  76% {
    transform: translate(1.4px, 0px);
  }
  78% {
    transform: translate(-1px, 0px);
  }
  80% {
    transform: translate(1.4px, 0px);
  }
  82% {
    transform: translate(-1.6px, -0px);
  }
  84% {
    transform: translate(-1.4px, 0px);
  }
  86% {
    transform: translate(1px, 0px);
  }
  88% {
    transform: translate(-1.4px, 0px);
  }
  90% {
    transform: translate(-1.6px, -0px);
  }
  92% {
    transform: translate(-1.4px, 0px);
  }
  94% {
    transform: translate(-1.6px, -0px);
  }
  96% {
    transform: translate(-1.4px, 0px);
  }
  98% {
    transform: translate(1.3px, 0px);
  }
}
.page-container {
  width: 100vw;
  height: calc(100vh - 280px);
  position: absolute;
  bottom: 0px;
  background-size: 100vw calc(100vh - 280px);
}

.forget {
  box-sizing: border-box;
  color: #323233b9;
  font-size: 26px;
  text-align: right;
  padding-right: 34px;
  padding-top: 20px;
}
</style>

<style lang="scss">
.van-cell__title {
  flex: none;
}
</style>
